import React, {
  FC,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import styled, { css, keyframes } from 'styled-components';

const BoothTierLabel = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(8px, 8px);
  background: #FFCB05;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.18);
  border-radius: 6px;
  padding: 4px 16px;
  max-width: calc(100% - 16px);
  overflow: hidden;
  text-overflow: ellipsis;
`;

const float = keyframes`
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
`;

const desktopAnimation = ({ animationDuration }: { animationDuration: number}) => (Boolean(animationDuration) && css`
  @media (min-width: 960px) {
    animation: ${animationDuration}s ${float} infinite linear paused;
    &:hover {
      animation: ${animationDuration}s ${float} infinite linear;
    }
  }
`);

const AutoScrollText = styled.p<{ animationDuration: number }>`
  margin: 0;
  white-space: nowrap;
  display: inline-block;

  @media (max-width: 959px) {
    display: initial;
  }
  ${desktopAnimation}
`;
interface BoothTierLabelAutoScrollProps {
  label: string;
}

const BoothTierLabelAutoScroll: FC<BoothTierLabelAutoScrollProps> = ({ label }: BoothTierLabelAutoScrollProps) => {
  const [animationDuration, setAnimationDuration] = useState(0);
  const divRef = useRef<HTMLDivElement>();

  useLayoutEffect(() => {
    setTimeout(() => {
      if (divRef.current) {
        const { clientWidth, scrollWidth } = divRef.current;
        // 100px per second
        if (scrollWidth > clientWidth) setAnimationDuration(Math.round(scrollWidth / 100));
      }
    }, 500);
  }, [label]);

  return (
    <BoothTierLabel
      className="booth-tier-label"
      ref={divRef}
    >
      <AutoScrollText animationDuration={animationDuration}>
        {label}
      </AutoScrollText>
    </BoothTierLabel>
  );
};

export default React.memo(BoothTierLabelAutoScroll);
